"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reservation = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var product_1 = require("../../model/product");
var service_1 = require("../../../library/base/service");
var Reservation = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Reservation, _super);
    function Reservation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '理财产品预约接口';
        _this.code = '101039';
        _this.desc = '理财产品预约接口';
        _this.requestParams = new product_1.ReservationRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Reservation;
}(service_1.BaseService));
exports.Reservation = Reservation;
//# sourceMappingURL=reservation.js.map